import { requester } from '@space-shell/config/request'

import { ToggleEndpoints } from './constants'

class FeatureToggleService {
  static async getFeatureToggle(toggleName: string, defaultValue?: boolean, unleashId?: string) {
    const { data } = await requester.get<boolean>(ToggleEndpoints.getFeatureToggle(toggleName), {
      params: { defaultValue, unleashId }
    })

    return data
  }
}

export default FeatureToggleService
